<div class="profile-selection-container">
  <app-info-box [title]="('steps.profileSelection.title' | translate) + typeAppointment.toLowerCase() + '?'" [description]="'steps.profileSelection.description' | translate">
  </app-info-box>
  <div class="selectors-container">
    @if (profiles?.relatedProfiles?.length >= 1) {
      <nz-radio-group [formControl]="profileSelected">
        <div class="selector">
          <label nz-radio [nzValue]="profiles">{{ profiles?.['fullName'] }}</label>
        </div>
        @for (profile of profiles.relatedProfiles; track profile) {
          <div class="selector">
            <label nz-radio [nzValue]="profile">{{ profile?.['fullName'] }}</label>
          </div>
        }
        <div class="selector last-element" (click)="createProfile()">
          <img src="/public/assets/images/plus-circle.svg" />
          <p>{{ 'steps.profileSelection.addPerson' | translate }}</p>
        </div>
      </nz-radio-group>
    }
  </div>
  @if (profileSelected.value || profiles?.relatedProfiles?.length === 0) {
    <div class="data-container">
      <h3>{{ 'steps.profileSelection.dataProfile' | translate }}</h3>
      <nz-divider></nz-divider>
      <div class="info-container">
        <div>
          <p class="title">
            {{ 'steps.profileSelection.profile' | translate }}
          </p>
          <p class="value">{{ profileSelected.value.fullName ? profileSelected.value.fullName : '-' }}</p>
        </div>
        <div>
          <p class="title">
            {{ 'steps.profileSelection.telephone' | translate }}
          </p>
          <p class="value">{{ profileSelected.value.phone ? profileSelected.value.phone : '-' }}</p>
        </div>
        <div>
          <p class="title">
            {{ 'steps.profileSelection.email' | translate }}
          </p>
          <p class="value">{{ profileSelected.value.email ? profileSelected.value.email : '-' }}</p>
        </div>
      </div>
      <div class="subtitle-container">
        @if (profileSelected.value.fullName && profileSelected.value.phone && profileSelected.value.email) {
          <span nz-icon nzType="info-circle" nzTheme="fill"></span>
          <p class="inner-container" innerHTML="{{ 'steps.profileSelection.dataVerify' | translate }}"></p>
          <a (click)="switchProfile(profileSelected)">{{ 'steps.profileSelection.goToProfile' | translate }}</a>
        } @else {
          <span nz-icon nzType="close-circle" nzTheme="fill"></span>
          <p class="inner-container" innerHTML="{{ 'steps.profileSelection.dataVerifyError' | translate }}"></p>
          <a (click)="switchProfile(profileSelected)">{{ 'steps.profileSelection.goToProfile' | translate }}</a>
        }
      </div>
    </div>
  }
</div>
